(() => {
  if(window.bbWishlistInitialized) return;
  window.bbWishlistInitialized=true;
  const key='bb_wishlist_v1';
  const page=document.querySelector('[data-wishlist-page]');
  const controls=()=>[...document.querySelectorAll('[data-wishlist-product]')];
  let saved=[];
  const valid=item=>item && typeof item.handle==='string' && /^[\p{L}\p{N}%_-]+$/u.test(item.handle) && typeof item.url==='string' && item.url.startsWith('/products/') && !item.url.includes('//');
  try {const data=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(data)) saved=data.filter(valid).slice(0,100);} catch(error) {}
  const labels=JSON.parse(document.querySelector('[data-wishlist-labels]').textContent);
  const catalog=page ? JSON.parse(page.querySelector('[data-wishlist-catalog]').textContent) : [];
  const catalogMap=new Map(catalog.map(item=>[item.handle,item]));
  const url=new URL(window.location.href);
  const shared=url.searchParams.get('saved');
  if(shared && page) {
    for(const handle of shared.split(',').slice(0,100)) {
      if(!/^[\p{L}\p{N}%_-]+$/u.test(handle) || saved.some(item=>item.handle===handle)) continue;
      saved.push(catalogMap.get(handle)||{handle,title:handle.replaceAll('-',' '),url:'/products/'+handle,image:null});
    }
  }
  const status=page?.querySelector('[data-wishlist-status]');
  const persist=()=>{try{localStorage.setItem(key,JSON.stringify(saved));return true;}catch(error){if(status)status.textContent=labels.storage_error;return false;}};
  if(shared && page) persist();
  const render=()=>{
    for(const control of controls()) {
      const item=JSON.parse(control.querySelector('[data-wishlist-item]').textContent);
      const button=control.querySelector('button');
      const active=saved.some(x=>x.handle===item.handle);
      button.hidden=false;button.textContent=active?labels.saved:(button.dataset.wishlistSaveLabel||labels.save);button.setAttribute('aria-pressed',String(active));
    }
    if(!page) return;
    const list=page.querySelector('[data-wishlist-items]');list.replaceChildren();
    if(status) status.textContent=saved.length?labels.count.replace('[count]',saved.length):labels.empty;
    for(const stored of saved) {
      const item=catalogMap.get(stored.handle)||stored;
      const li=document.createElement('li');const link=document.createElement('a');link.href=item.url;
      if(item.image){try{const imageUrl=new URL(item.image,window.location.origin);if(imageUrl.origin===window.location.origin || imageUrl.hostname==='cdn.shopify.com'){const img=document.createElement('img');img.src=imageUrl.href;img.alt=item.title;img.loading='lazy';link.append(img);}}catch(error){}}
      const h2=document.createElement('h2');const title=document.createElement('a');title.href=item.url;title.textContent=item.title;h2.append(title);
      const view=document.createElement('a');view.href=item.url;view.textContent=labels.view;
      const p=document.createElement('p');p.append(view);
      const remove=document.createElement('button');remove.type='button';remove.className='button button--secondary';remove.textContent=labels.remove;remove.setAttribute('aria-label',labels.remove+' '+item.title);
      remove.addEventListener('click',()=>{saved=saved.filter(x=>x.handle!==item.handle);render();persist();});
      li.append(link,h2,p,remove);list.append(li);
    }
    page.querySelector('[data-wishlist-copy]').disabled=!saved.length;
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('[data-wishlist-product] button');
    if(!button) return;
    const control=button.closest('[data-wishlist-product]');
    const item=JSON.parse(control.querySelector('[data-wishlist-item]').textContent);
    if(!valid(item)) return;
    const active=saved.some(x=>x.handle===item.handle);
    saved=active?saved.filter(x=>x.handle!==item.handle):[...saved,item].slice(-100);
    render();const ok=persist();
    const feedback=control.querySelector('[role="status"]');
    if(feedback) feedback.textContent=ok?(active?labels.removed:labels.added):labels.storage_error;
  });
  new MutationObserver(records=>{
    if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches?.('[data-wishlist-product]') || node.querySelector?.('[data-wishlist-product]'))))) render();
  }).observe(document.body,{childList:true,subtree:true});
  page?.querySelector('[data-wishlist-copy]').addEventListener('click',async()=>{
    const link=new URL(window.location.pathname,window.location.origin);link.searchParams.set('saved',saved.map(x=>x.handle).join(','));
    try {await navigator.clipboard.writeText(link.href);status.textContent=labels.copied;}
    catch(error){const input=document.createElement('input');input.value=link.href;input.readOnly=true;input.setAttribute('aria-label',labels.copy);status.replaceChildren(input);input.focus();input.select();}
  });
  window.addEventListener('storage',event=>{if(event.key===key){try{saved=JSON.parse(event.newValue||'[]').filter(valid);render();}catch(error){}}});
  render();
})();
